import { render, staticRenderFns } from "./ProductSorting.vue?vue&type=template&id=274bb22b&scoped=true&"
import script from "./ProductSorting.vue?vue&type=script&lang=js&"
export * from "./ProductSorting.vue?vue&type=script&lang=js&"
import style0 from "./ProductSorting.vue?vue&type=style&index=0&id=274bb22b&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bb22b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconDownArrow: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconDownArrow.vue').default})
